<div class="create_popup">
    <div class="modal-body">
        <form [formGroup]="createForm" class="mb-3">
            <div class="product-row">
                <div class="row">
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Customer & Warehouse<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select appendTo="body" formControlName="mappingId" placeholder="Select Customer" (change)="selectCustomer($event)">
                                <ng-option *ngFor="let item of accountMappingList" [value]="item.id">{{item.accountName}} - {{item.warehouseName}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <!-- <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Customer<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select appendTo="body" formControlName="accountId" placeholder="Select Customer" (change)="selectCustomer($event)">
                                <ng-option *ngFor="let item of accountList" [value]="item.id">{{item.accountName}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Warehouse name<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select  appendTo="body" placeholder="Select Warehouse" formControlName="warehouseId">
                                <ng-option *ngFor="let item of warehouseList" [value]="item.warehouseId">{{item.warehouseName}}</ng-option>
                            </ng-select>
                        </div>
                    </div> -->
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Financial Year <span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select #ngFYSelect [multiple]="false"
                                formControlName="financialYearId" appendTo="body" placeholder="">
                                <ng-option *ngFor="let item of financialYear" [value]="item?.id">{{item?.name}}</ng-option>
                                <!-- add more dynamic  -->
                                <ng-template ng-footer-tmp>
                                    <div class="d-flex justify-content-end">
                                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('financialYear')" >Add More</button>
                                    </div>
                                  </ng-template>
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 mb-3">
                        <div class="col-md-12">
                            <b>Month<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                        <p-calendar appendTo="body" class="scheduledDate" name="MONTH" formControlName="budgetDate" view="month" dateFormat="MM"></p-calendar>

                            <!-- <p-calendar
                            (onSelect)="setMonth($event)"
                            formControlName="budgetDate"
                            view="month"
                            dateFormat="dd-mm-yy"
                            inputId="monthpicker"
                            appendTo="body"
                            class="scheduledDate"
                        ></p-calendar> -->
                             <!-- <p-calendar class="scheduledDate" formControlName="budgetDate"  inputId="touchui" view="month" inputId="icon" appendTo="body"></p-calendar> -->

                            <!-- <p-calendar class="scheduledDate" formControlName="budgetDate" view="month"
                                 appendTo="body">
                            </p-calendar> -->
                        </div>
                    </div>

                   

                    <!-- <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>WH Type<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12 disabled">
                            <ng-select [multiple]="false"
                            formControlName="warehouseTypeId" appendTo="body" placeholder="">
                            <ng-option *ngFor="let item of warehouseTypeList" [value]="item?.id">{{item?.name}}</ng-option>
                        </ng-select>
                        </div>
                    </div> -->

                    <!-- <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Zone<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select [multiple]="false"
                            formControlName="zoneId" appendTo="body" placeholder="">
                            <ng-option *ngFor="let item of zone" [value]="item?.id">{{item?.name}}</ng-option>
                            <ng-template ng-footer-tmp>
                                <div class="d-flex justify-content-end">
                                    <button class="btn ng-select-btn btn-primary ms-1" (click)="create('zone')" >Add More</button>
                                </div>
                              </ng-template>
                        </ng-select>
                        </div>
                    </div> -->

                    

                    <!-- <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Customer Owned<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select [multiple]="false" formControlName="customerOwned" appendTo="body" placeholder="">
                                <ng-option value="1">Yes</ng-option>
                                <ng-option value="0">No</ng-option>
                            </ng-select>
                        </div>
                    </div> -->
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Expense Associated<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select [multiple]="false" formControlName="expenseId" appendTo="body" placeholder="">
                                <ng-option *ngFor="let item of expenseTypeList" [value]="item.expenseId">{{item?.expense}}</ng-option>
                                <!-- <ng-template ng-footer-tmp>
                                    <div class="d-flex justify-content-end">
                                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('expenseType')" >Add More</button>
                                    </div>
                                  </ng-template> -->
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Budget Amount<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input (keypress)="sharedService.isNumberKey($event)" type="text" trim="blur" class="form-control"
                                    formControlName="approvedBudget" /></span>
                        </div>
                    </div>
                    <!-- <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Total Expense Amount<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="totalExpenseAmount" /></span>
                        </div>
                    </div> -->
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Budget Type<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select #ngBudgetTypeSelect [multiple]="false" formControlName="budgetTypeId" appendTo="body" placeholder="">
                                <ng-option *ngFor="let item of budgetType" [value]="item.id">{{item?.name}}</ng-option>
                                <ng-template ng-footer-tmp>
                                    <div class="d-flex justify-content-end">
                                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('budgetType')" >Add More</button>
                                    </div>
                                  </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Reference<span *ngIf="!multipleEdit" style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select #ngRefSelect [multiple]="false" formControlName="referenceId" appendTo="body" placeholder="">
                                <ng-option *ngFor="let item of referenceList" [value]="item.id">{{item?.name}}</ng-option>
                                <ng-template ng-footer-tmp>
                                    <div class="d-flex justify-content-end">
                                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('reference')" >Add More</button>
                                    </div>
                                  </ng-template>
                            </ng-select>
                        </div>
                    </div>

                    
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Budget Updated-Remark: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="input" trim="blur" class="form-control"
                                    formControlName="remarks" /></span>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 mb-3 ">
                        <div class="col-md-12">
                            <b>Budget Proof: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="file" trim="blur" class="form-control" (change)="selectFile($event)" #uploadInput
                                    formControlName="budgetProofFile" />
                                <span style="font-size: smaller;" *ngIf="budgetProofURLs">
                                    <a [href]="budgetProofURLs"  target="_blank" rel="noopener noreferrer">{{ budgetProofURLs.split('/').pop() }}</a>
                                </span>
                                </span>
                        </div>
                        <div *ngIf="progress>0" class="progress mb-4 col-lg-6 col-sm-6 col-12">
                            <div
                              class="progress-bar progress-bar-info"
                              role="progressbar"
                              attr.aria-valuenow="{{ progress }}"
                              aria-valuemin="0"
                              aria-valuemax="100"
                              [ngStyle]="{ width: progress + '%' }"
                            >
                              {{ progress }}%
                            </div>
                        </div>
                        <div *ngIf="budgetProofURLs ? budgetProofURLs.length > 0 : []">
                            <p class="chip d-flex justify-content-between align-items-center" style="margin: 0;" *ngFor="let item of budgetProofURLs">
                                <span class="mr-3 chip-item">{{item}}</span>
                                <span (click)="removeBudgetProofURLs(item)">
                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#787878"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6.99486 7.00636C6.60433 7.39689 6.60433 8.03005 6.99486 8.42058L10.58 12.0057L6.99486 15.5909C6.60433 15.9814 6.60433 16.6146 6.99486 17.0051C7.38538 17.3956 8.01855 17.3956 8.40907 17.0051L11.9942 13.4199L15.5794 17.0051C15.9699 17.3956 16.6031 17.3956 16.9936 17.0051C17.3841 16.6146 17.3841 15.9814 16.9936 15.5909L13.4084 12.0057L16.9936 8.42059C17.3841 8.03007 17.3841 7.3969 16.9936 7.00638C16.603 6.61585 15.9699 6.61585 15.5794 7.00638L11.9942 10.5915L8.40907 7.00636C8.01855 6.61584 7.38538 6.61584 6.99486 7.00636Z" fill="#787878"></path> </g></svg>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>


            </div>
        </form>

        <!-- <button type="submit" class="btn btn-cancel mr-3" >Cancel</button> -->
        <button type="submit" class="btn btn-primary mr-3" [disabled]="!createForm.valid" (click)="submitForm()">Submit</button>

    </div>